import { GoogleGenAI } from "@google/genai";
export const GEMINI_MODEL = "models/gemini-2.5-flash";
export function getGeminiClient() {
  const apiKey = process.env.REACT_APP_GEMINI_API_KEY;
  if (!apiKey) return null;
  return new GoogleGenAI({ apiKey });
}